import React from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Col, Row, Tabs, TabsProps, Typography} from "antd";
import {StyledUserApplicationBreadcrumb} from "./index.styles";
import {MyButton} from "../../../../../common/MyButton/MyButton";

export const UserApplicationBreadcrumb = ({
                                              setCurrentTab,
                                              educationOrders,
                                              currentTab,
                                              title,
                                          }: any) => {
    const navigate = useNavigate();
    const {t} = useTranslation(["breadcrumbs", "admission"])
    const [searchParams, setSearchParams] = useSearchParams();


    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <Row>
                <p>{t("breadcrumbs:send")} ({educationOrders?.data && educationOrders?.data.length > 0 ? educationOrders.data.filter((educationOrder:any) => educationOrder.status === "0").length : "..."})</p>
                {/*<p>{t("send")}</p>*/}
                {/*<span className="applicationCount">(0)</span>*/}
            </Row>,
        },
        // {
        //   key: '3',
        //   label: <Row>
        //     <p>{t("underConsideration")}</p>
        //     <span className="applicationCount">(0)</span></Row>,
        // },
        {
            key: '2',
            label: <Row>
                <p>{t("breadcrumbs:accepted")} ({educationOrders?.data && educationOrders?.data.length > 0 ? educationOrders.data.filter((educationOrder:any) => educationOrder.status === "2").length : "..."})</p>
                {/*<p>{t("accepted")}</p>*/}
                {/*<span className="applicationCount">(0)</span>*/}
            </Row>,
        },
        {
            key: '3',
            label: <Row>
                <p>{t("breadcrumbs:rejected")} ({educationOrders?.data && educationOrders?.data.length > 0 ? educationOrders.data.filter((educationOrder:any) => educationOrder.status === "3" || educationOrder.status === "5").length : "..."})</p>
                {/*<p>{t("rejected")}</p>*/}
                {/*<span className="applicationCount">(0)</span>*/}
            </Row>,
        },
        {
            key: '4',
            label: <Row>
                {/*<p>{t("draft")}</p>*/}
                <p>{t("breadcrumbs:draft")}</p>
                {/*<span className="applicationCount">(0)</span>*/}
            </Row>,
        },
    ]
    const onChangeTab = (key:string) => {
        setCurrentTab(key)
        setSearchParams({
            tab: key
        })
    }

    const checkTypes = (data: any) => {
        if (data) {

            let hasType1 = false;
            let hasType2 = false;

            for (const application of data) {
                if ((application.status == "2" || application.status === "0") && application.education_type === "1") {
                    hasType1 = true;
                }
                if ((application.status == "2" || application.status === "0") && application.education_type === "2") {
                    hasType2 = true;
                }
                if (hasType1 && hasType2) {
                    break;
                }
            }

            if (hasType1 && hasType2) {
                return true
            } else {
                return false
            }
        } else {
            return true
        }
    }

    return(
        <StyledUserApplicationBreadcrumb>
            <Col span={20} style={{margin: "auto"}}>
                <Row justify="space-between">
                    <Row>
                        <Typography.Title level={3}>
                            {title}
                        </Typography.Title>
                    </Row>

                    <Col>
                        <MyButton loading={!educationOrders.success} disabled={checkTypes(educationOrders?.data && educationOrders?.data)} onClick={() => navigate("/entrant-admission")} title={t("admission:stepsMainCaptions.sendApplication")}
                                  height={40}
                                  type="primary"/>
                    </Col>
                </Row>

                <Tabs items={items} onChange={onChangeTab} activeKey={currentTab}/>
            </Col>
        </StyledUserApplicationBreadcrumb>
    )
}